import { TAX_FORM } from './form-tax-types';
import { showToast } from '../../toasts';
import { checkForSelectValue } from '../form-helpers';

import UpdateTaxes from '../../../routes/update-taxes';

/**
 * Function to post a new tax
 * 
 * @returns void
 */
const UpdateIndividualTax = async () => {
  const { txForm, txType, txPartner, txName, txAmount, txSubmitButton } = TAX_FORM;

  const validateForm = () => {
    txForm.classList.add('was-validated');

    checkForSelectValue(txType, 'Tax Type', 'tax-type');
    if ( txPartner ) {
      checkForSelectValue(txPartner, 'Partner', 'partner');
    }

    const isValid = (txType ? txType.getAttribute('data-value') != null : false) && 
                  (txPartner ? txPartner.getAttribute('data-value') != null : true);

    return txForm.checkValidity() && isValid;
  }

  const handleUpdateTax = async (awsData: any) => {
    const { body } = await UpdateTaxes(awsData);

    if ( body ) {
      showToast('aafp_toast', `${txName.value} group has been updated`);
      setTimeout(() => {
        location.href = '/terminal-taxes/';
      }, 1500);
    }
  }

  txForm.addEventListener('submit', event => {
    event.preventDefault();
    event.stopPropagation();

    if ( validateForm() ) {
      txForm.classList.remove('form-control:valid');
      txSubmitButton.classList.add('aafp_button-loading');  

      const awsData = {
        taxId: +txName.getAttribute('data-id')!,
        name: txName.value,
        amount: txAmount.valueAsNumber,
        type: String(txType.getAttribute('data-value')),
        partnerId: Number(txPartner.getAttribute('data-value'))
      }

      handleUpdateTax(awsData);
    }
  });
}

export default UpdateIndividualTax;